/**
 * 
 * @param {string} type 
 * @returns string
 * 
 * funcion para crear el nombre que tendra el archivo a descargar
 */
export const formatFileName = (type) => {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1; // Months start at 0!
    let day = today.getDate();

    if (day < 10) day = '0' + day;
    if (month < 10) month = '0' + month;

    const formattedName = `${year}_${month}_${day}_${type}_reporte`
    return formattedName
}

/**
 * 
 * @param {string} type 
 * @returns string
 * 
 * funcion para devolver el string del nombre del tipo de servicio
 */
export const formatType = (type) => {
    const formattedType = type.toLocaleLowerCase() === 'comercios' ? 'commerces' : 'yummers';
    return formattedType
}
